import { Extension } from '@tiptap/core';
import {
    ShortAnswerAnswerNode,
    ShortAnswerAnswerNodeHeadless,
    ShortAnswerAnswerWrapperNode,
    ShortAnswerAnswerWrapperNodeHeadless,
    ShortAnswerExplanationNode,
    ShortAnswerExplanationNodeHeadless,
    ShortAnswerHintNode,
    ShortAnswerHintNodeHeadless,
    ShortAnswerNode,
    ShortAnswerNodeHeadless,
    ShortAnswerQuestionNode,
    ShortAnswerQuestionNodeHeadless,
} from './short-answer-extension';

export const ShortAnswerHeadless = Extension.create({
    name: 'shortAnswerWrapper',

    addOptions() {
        return {};
    },

    addExtensions() {
        return [
            ShortAnswerNodeHeadless,
            ShortAnswerQuestionNodeHeadless,
            ShortAnswerAnswerNodeHeadless,
            ShortAnswerAnswerWrapperNodeHeadless,
            ShortAnswerHintNodeHeadless,
            ShortAnswerExplanationNodeHeadless,
        ];
    },
});

export const ShortAnswer = ShortAnswerHeadless.extend({
    addExtensions() {
        return [
            ShortAnswerNode,
            ShortAnswerQuestionNode,
            ShortAnswerAnswerNode,
            ShortAnswerAnswerWrapperNode,
            ShortAnswerHintNode,
            ShortAnswerExplanationNode,
        ];
    },
});

export default ShortAnswer;
